import { render } from "./rqzjView.vue?vue&type=template&id=79fe6d92"
import script from "./rqzjView.vue?vue&type=script&lang=js"
export * from "./rqzjView.vue?vue&type=script&lang=js"

import "./rqzjView.vue?vue&type=style&index=0&id=79fe6d92&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__